// extracted by mini-css-extract-plugin
export default {"customTooltip":"customTooltipiNs7d","customTopPlacement":"customTopPlacementcQDSY","textWrap":"textWrapsEmrJ"};